import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { CompanyInfos } from './company-infos.types';

@Injectable({ providedIn: 'root' })
export class CompanyInfosService {
    private _httpClient = inject(HttpClient);
    private _companyInfos: BehaviorSubject<CompanyInfos | null> =
        new BehaviorSubject<CompanyInfos | null>(null);

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Setter & getter for user
     *
     * @param value
     */
    set companyInfos(value: CompanyInfos | null) {
        // Store the value
        this._companyInfos.next(value);
    }

    get companyInfos$(): Observable<CompanyInfos | null> {
        return this._companyInfos.asObservable();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    getByCompany(companyId: string): Observable<CompanyInfos | null> {
        return this._httpClient
            .get<CompanyInfos | null>(`api/company-data/infos/${companyId}`)
            .pipe(
                tap((response) => {
                    this._companyInfos.next(response);
                })
            );
    }

    create(companyInfos: CompanyInfos): Observable<CompanyInfos> {
        return this._httpClient
            .post<CompanyInfos>(`api/company-data/infos`, companyInfos)
            .pipe(
                tap((response) => {
                    this._companyInfos.next(response);
                })
            );
    }

    update(
        id: string,
        companyInfos: Partial<CompanyInfos>
    ): Observable<CompanyInfos> {
        return this._httpClient
            .patch<CompanyInfos>(`api/company-data/infos/${id}`, companyInfos)
            .pipe(
                tap((response) => {
                    this._companyInfos.next(response);
                })
            );
    }
}
